import React from 'react';
import '@css/Admin/index.scss';
import Header from './partials/Header';
import Content from './partials/Content';
import Dashboard from './pages/dashboard/main';
import AdminConfig from '@config/admin';
import { slugfy } from '@utils/helpers';
import { connect } from 'react-redux';

import {
    Switch,
    Route,
    useRouteMatch,
    // Redirect,
} from "react-router-dom";

const Partner = props => {
    let { path } = useRouteMatch();
    let theme = AdminConfig.themes[slugfy(props?.user?.data?.permission)] || AdminConfig.themes.vendedor;

    return <Switch>
      <React.Fragment>
        <div className="flex flex-col admin">
          <Header theme={theme} />
          <div className="flex flex-row admin-body">
            <Content>
              <Route path={`${path}`}>
                <Dashboard theme={theme} />
              </Route>
            </Content>
          </div>
        </div>
      </React.Fragment>
    </Switch>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Partner);
